import { useCallback, useEffect, useMemo, useState } from "react";
import Loading from "../loading/Loading";
import { Alert, Button, Col, Container, Form, Row, Table } from "react-bootstrap";
import { getLibroProducts } from "../../controllers/products";
import { fetchStripeSessionSecret, submitMaterialOrder } from "../../controllers/orders";
import { stripeKey } from "../../controllers/config";
import { loadStripe } from "@stripe/stripe-js";
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { useToast } from "../toast/ToastContext";

function ComunidadOrdenarLibros({ comunidadId, matrimonioPresidente, matrimonioTesorero, type, personalRecipient, usePersonalRecipient = false, comunidades = [] }) {
  const [libros, setLibros] = useState([]);
  const [cantidades, setCantidades] = useState({});
  const [presidentes, setPresidentes] = useState(matrimonioPresidente);
  const [tesoreros, setTesoreros] = useState(matrimonioTesorero);
  const [selectedComunidadId, setSelectedComunidadId] = useState(comunidadId || 'regional');
  const [lineItems, setLineItems] = useState();
  const [session, setSession] = useState('');
  const [onPaymentComplete, setOnPaymentComplete] = useState(false);
  const [order, setOrder] = useState();
  const [orderRegistered, setOrderRegistered] = useState(false);
  const [paySelection, setPaySelection] = useState();
  const showToast = useToast();
  const stripePromise = loadStripe(stripeKey);

  useEffect(() => {
    if (!comunidades.length) {
      return;
    }
    if (selectedComunidadId === 'regional') {
      return;
    }
    const currentSelectionExists = comunidades.some((comunidad) => Number(comunidad.comunidad_id) === Number(selectedComunidadId));
    if (!selectedComunidadId || !currentSelectionExists) {
      setSelectedComunidadId(comunidadId || 'regional');
    }
  }, [comunidades, comunidadId, selectedComunidadId]);

  useEffect(() => {
    if (comunidadId && !comunidades.some((comunidad) => Number(comunidad.comunidad_id) === Number(comunidadId))) {
      setSelectedComunidadId(comunidadId);
    }
  }, [comunidadId, comunidades]);
  
  useEffect(() => {
    loadLibros();
    if (!presidentes && !tesoreros) {
      getTesoreroAndPresident();
    }
  }, []);
  useEffect(() => {
    console.log('session update:', session)
  }, [session]);
  useEffect(() => {
    if (onPaymentComplete) {
      submitOrder();
    }
  }, [onPaymentComplete]);

  async function loadLibros() {
    try {
      const l = await getLibroProducts();
      setLibros(Array.isArray(l) ? l : []);
    } catch (error) {
      setLibros([]);
    }
  }
  async function getTesoreroAndPresident() {}

  function updateCantidad(l, value) {
    console.log(l, value);
    let c = Object.assign({}, cantidades);
    if (!c[l.productId]) {
      c[l.productId] = {
        label: l.label,
        productType: l.productType,
        productId: l.productId,
        productPrice: l.costo,
        quantity: 0
      }
    }
    if(!value || isNaN(value)) {
      c[l.productId].quantity = 0;
    }
    else {
      c[l.productId].quantity = parseInt(value);
    }
    setCantidades(c);
  }

  function renderLibros() {
    const safeLibros = Array.isArray(libros) ? libros : [];
    return safeLibros.map((l) => {
      // console.log('libro', cantidades, l.productId, cantidades[l.productId]?.cantidad);
      return <tr key={`product-row${l.productId}`}>
      <td>{l.label}</td>
      <td>${l.costo}</td>
      <td>
        <Form.Group className="mb-3" controlId={`cantidad-product-${l.productId}`}>
          <Form.Control name={`product--${l.productId}`} type="tel" placeholder="Cantidad" value={cantidades[l.productId]?.quantity || ''} onChange={(e) => updateCantidad(l, e.target.value)} />
        </Form.Group>
      </td>
      <td>${!isNaN(cantidades[l.productId]?.quantity) ? l.costo * cantidades[l.productId]?.quantity : 0}</td>
    </tr>
    })
  }

  function getLineItems() {
    const li = Object.values(cantidades).filter(c => c.quantity > 0);
    return li;
  }
  async function payLater(e) {
    e.preventDefault();
    const li = getLineItems();
    console.log('line items: ', li);
    if (!canSubmitOrder) {
      showToast({
        message: 'No hay un destinatario válido para esta orden. Selecciona otra comunidad o revisa la información del contacto.',
        bg: 'danger',
        autohide: true,
        delay: 8000,
        title: 'Sin destinatario'
      });
      return;
    }
    if (li.length) {
      setLineItems(li);
      setPaySelection('payLater');
      try {
        let r = await submitMaterialOrder(`membership-${contacto.membership_id}-${Date.now()}`, '', li, contacto, false);
        setOrder(r.order);
        setOrderRegistered(true);
        showToast({
          message: `La orden se creó correctamente. Número de orden: ${r.order.order_id}.`,
          bg: 'success',
          autohide: true,
          delay: 8000,
          title: 'Orden creada'
        });
      }
      catch (e) {
        showToast({
          message: 'Ocurrió un error al procesar la orden. Intente de nuevo más tarde.',
          bg: 'danger',
          autohide: true,
          delay: 8000,
          title: 'Error al crear orden'
        });
      }
      
    }
  }

  let total = 0;
  Object.values(cantidades).forEach(c => {
    total += c.quantity * c.productPrice;
  });

  async function payNow(e) {
    e.preventDefault();
    const lineItems = Object.values(cantidades).filter(c => c.quantity > 0);
    console.log('line items: ', lineItems);
    if (!canSubmitOrder) {
      showToast({
        message: 'No hay un destinatario válido para esta orden. Selecciona otra comunidad o revisa la información del contacto.',
        bg: 'danger',
        autohide: true,
        delay: 8000,
        title: 'Sin destinatario'
      });
      return;
    }
    if (lineItems.length) {
      setLineItems(lineItems);
      setPaySelection('payNow');
    }
  }

  const onStripePaymentComplete = useCallback(() => {
    setOnPaymentComplete(true);
  }, [session, lineItems, order]);

  const normalizePersonalRecipient = useCallback(() => {
    if (!usePersonalRecipient || !personalRecipient) {
      return null;
    }

    const membership = personalRecipient.memberships?.[0];
    const fullName = [personalRecipient.profile?.first_name_1, personalRecipient.profile?.first_name_2, personalRecipient.profile?.last_name]
      .filter(Boolean)
      .join(' ')
      .trim();

    return {
      membership_id: membership?.membership_id,
      user_id: personalRecipient.user_id,
      label: fullName || personalRecipient.email,
      profile: personalRecipient.profile,
      user: {
        email: personalRecipient.email,
        profile: personalRecipient.profile,
      },
      membership,
    };
  }, [personalRecipient, usePersonalRecipient]);

  const normalizeRecipientContact = useCallback((person) => {
    if (!person) {
      return null;
    }

    const profile = person.profile || person.user?.profile || person.user?.user?.profile || person.contact?.profile || null;
    if (!profile) {
      return person;
    }

    return {
      ...person,
      profile,
      user: {
        ...(person.user || {}),
        profile,
      },
    };
  }, []);

  const resolveContactProfile = useCallback((person, fallbackPerson = null) => {
    return person?.profile || person?.user?.profile || person?.user?.user?.profile || person?.contact?.profile ||
      fallbackPerson?.profile || fallbackPerson?.user?.profile || fallbackPerson?.user?.user?.profile || fallbackPerson?.contact?.profile || null;
  }, []);

  const selectedComunidad = selectedComunidadId === 'regional'
    ? null
    : comunidades.find((comunidad) => Number(comunidad.comunidad_id) === Number(selectedComunidadId)) || null;
  const regionalContacto = normalizeRecipientContact(tesoreros || presidentes || null);

  const selectedContacto = useMemo(() => {
    if (usePersonalRecipient) {
      return normalizePersonalRecipient();
    }

    if (!selectedComunidad) {
      return regionalContacto;
    }

    return normalizeRecipientContact(
      selectedComunidad?.tesorero || selectedComunidad?.presidente || regionalContacto || null
    ) || regionalContacto;
  }, [selectedComunidad, regionalContacto, usePersonalRecipient, normalizePersonalRecipient]);

  let contacto = selectedContacto;

  const normalizedProfile = resolveContactProfile(contacto, regionalContacto);
  if (contacto && !contacto.profile && normalizedProfile) {
    contacto = {
      ...contacto,
      profile: normalizedProfile,
      user: {
        ...(contacto.user || {}),
        profile: normalizedProfile,
      },
    };
  }

  const contactProfile = resolveContactProfile(contacto, regionalContacto);
  const contactName = contacto?.label || [
    contactProfile?.first_name_1,
    contactProfile?.first_name_2,
    contactProfile?.last_name,
  ].filter(Boolean).join(' ').trim() || 'Destinatario';

  if (!contacto && selectedComunidad) {
    contacto = {
      label: selectedComunidad.label,
      profile: {
        first_name_1: selectedComunidad.label,
        last_name: '',
        address_1: selectedComunidad.address_1,
        address_2: selectedComunidad.address_2,
        city: selectedComunidad.city,
        state: selectedComunidad.state,
        zip_code: selectedComunidad.zip_code,
      },
      membership_id: selectedComunidad?.tesorero?.membership_id ?? selectedComunidad?.presidente?.membership_id ?? selectedComunidad?.membership_id ?? null,
      user_id: selectedComunidad?.tesorero?.user_id ?? selectedComunidad?.presidente?.user_id ?? selectedComunidad?.user_id ?? null,
    };
  }

  const addressLine = [contactProfile?.address_1 || selectedComunidad?.address_1, contactProfile?.address_2 || selectedComunidad?.address_2].filter(Boolean).join(' ').trim();
  const cityLine = [contactProfile?.city || selectedComunidad?.city, contactProfile?.state || selectedComunidad?.state, contactProfile?.zip_code || selectedComunidad?.zip_code].filter(Boolean).join(', ').trim();
  const hasContactInfo = Boolean(contacto && (contactName || addressLine || cityLine));
  const hasRecipientMembership = Boolean(contacto?.membership_id || (usePersonalRecipient && personalRecipient?.memberships?.[0]?.membership_id));
  const canSubmitOrder = hasRecipientMembership;
  const showRecipientWarning = !hasRecipientMembership && Boolean(contacto || selectedComunidad || !usePersonalRecipient);

  const submitOrder = useCallback(async () => {
    setOrderRegistered(true);
    if (order?.order_id) {
      showToast({
        message: `La orden se envió a tesorería nacional con éxito. Número de orden: ${order.order_id}.`,
        bg: 'success',
        autohide: true,
        delay: 8000,
        title: 'Orden enviada'
      });
    }
  }, [session, lineItems, order]);

  let mainContent;

  if (!contacto && !selectedComunidad && !comunidades.length) {
    let apostolado;
    switch(type) {
      case 'region': apostolado = 'Matrimonio Coordinador de Región'; break;
      case 'diocesis': apostolado = 'Matrimonio Delegado Diocesano'; break;
      
      case 'comunidad':
      default:
          apostolado = 'Matrimonio Presidente o Tesorero de Comunidad';
    }
    return <Container>
      <Alert variant="warning">No se encontró {apostolado}.</Alert>
    </Container>
  }

  if (lineItems && paySelection === 'payNow') {
    const stripeOptions = {
      fetchClientSecret: fetchStripeSessionSecret(lineItems, null, setSession, contacto, setOrder),
      onComplete: onStripePaymentComplete,
    };
    mainContent = <div className="order-payment-wrapper">
      {order && !orderRegistered && <p className="text-success">La orden se creó correctamente. Número de orden: {order.order_id}. Por favor realiza el pago.</p>}
      {onPaymentComplete && session && orderRegistered && <p className="text-success">Pago completado. La orden se envió a los tesoreros nacionales con éxito.</p>}
      <EmbeddedCheckoutProvider
        stripe={stripePromise}
        options={stripeOptions}
      >
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  }
  else if (lineItems && paySelection === 'payLater') {
    if (order) {
      mainContent = <p className="text-success">La orden se creó correctamente. Número de orden: {order.order_id}. Por favor realiza el pago lo antes posible.</p>
    }
    else {
      mainContent = <Loading text="Estamos procesando tu orden. Espera en momento..." />
    }
  }
  else {
    mainContent = <>
      <Table>
          <thead>
            <tr>
              <td>Producto</td>
              <td>Costo</td>
              <td>Cantidad</td>
              <td>Monto</td>
            </tr>
          </thead>
          <tbody> 
            {renderLibros()}
            <tr>
              <td></td>
              <td></td>
              <td>Total</td>
              <td>${total}</td>
            </tr>
          </tbody>
        </Table>
        <Row className="mb-3 justify-content-md-end">
          <Col md={3}><Button key='submit-btn-1' type='button' variant='primary' onClick={payNow} disabled={!canSubmitOrder}>Ordenar y pagar</Button></Col>
          <Col md={3}><Button key='submit-btn-2' type='button' variant='secondary' onClick={payLater} disabled={!canSubmitOrder}>Ordenar y pagar después</Button></Col>
        </Row>
    </>
  }

  return <Container>
    <Form onSubmit={payNow}>
      <Row>
        <h2>Ordenar libros</h2>

        {comunidades.length > 0 && (
          <Form.Group className="mb-3" controlId="comunidad-select">
            <Form.Label>Comunidad</Form.Label>
            <Form.Select
              value={selectedComunidadId ?? ''}
              onChange={(e) => setSelectedComunidadId(e.target.value)}
            >
              <option value="regional">Orden regional</option>
              {comunidades.map((comunidad) => (
                <option key={comunidad.comunidad_id} value={comunidad.comunidad_id}>
                  {comunidad.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}

        {showRecipientWarning && !hasRecipientMembership && (
          <Alert variant="warning">No se encontró un destinatario válido para esta orden. Selecciona otra comunidad o revisa la información del contacto.</Alert>
        )}

        {contacto && hasContactInfo && (
          <>
            <p>Los libros se enviarán a la siguiente dirección:</p>
            <p>
              {usePersonalRecipient ? `${contacto.profile?.first_name_1 ?? ''} ${contacto.profile?.last_name ?? ''}`.trim() || contacto.label : contactName}<br />
              {addressLine && <>{addressLine}<br /></>}
              {cityLine && <>{cityLine}</>}
            </p>
          </>
        )}
      </Row>
      <Row>
        {mainContent}
      </Row>
    </Form>
  </Container>;
}

export default ComunidadOrdenarLibros;